export default "__VITE_ASSET__1b3b59b5__"